import { PayloadAction } from "@reduxjs/toolkit";
import { UpsellState } from "../../models/UpsellsState";
import { UploadUpsellIconPayload } from "../../payload/UploadUpsellIcon/UploadUpsellIconPayload";

const uploadUpsellIconFetch = (state: UpsellState, action: PayloadAction<UploadUpsellIconPayload>) => {
    state.isLoading = true;
}

export default uploadUpsellIconFetch;